import { useState } from "react";
import { PiCaretDownLight } from "react-icons/pi";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  UncontrolledDropdown,
} from "reactstrap";
import NormalInput2 from "./NormalInput2";

const StateSelectInput = ({
  options,
  value,
  setValue,
  placeholder,
  label,
  className,
}) => {
  const [searchedResults, setSearchedResults] = useState([]);

  const handleSearch = (value) => {
    if (value !== "") {
      let array = [...options]?.filter((item) =>
        item?.name?.toUpperCase()?.includes(value?.toUpperCase())
      );
      setSearchedResults(array);
    } else setSearchedResults([]);
  };
  return (
    <div>
      {label && <Label className="figma-input-label">{label}</Label>}
      <UncontrolledDropdown className="normal-input-2">
        <DropdownToggle
          className={`f-4 py-2 px-3 border-none text-black full-width ${className} d-flex justify-content-between align-items-center`}
        >
          {value
            ? typeof value === "object"
              ? value?.title ?? value?.name
              : value
            : placeholder}

          <div className="color-primary-black-2">
            <PiCaretDownLight size={25} />
          </div>
        </DropdownToggle>
        <DropdownMenu className="full-width">
          <div className="outer-transparent-shadow">
            <NormalInput2
              placeholder={"Search here"}
              style={{ borderRadius: 0 }}
              setValue={(v) => handleSearch(v)}
              className={"bg-transparent"}
            />
          </div>
          <div
            className=""
            style={{
              height: "300px",
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            {searchedResults?.length === 0
              ? options?.map((item) => (
                  <DropdownItem
                    tag={"div"}
                    onClick={() => setValue(item)}
                    className="d-flex p-2 cursor-pointer br-0 justify-content-start"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <small className="f-5 ">{item?.name}</small>
                    </div>
                  </DropdownItem>
                ))
              : searchedResults?.map((item) => (
                  <DropdownItem
                    tag={"div"}
                    onClick={() => setValue(item)}
                    className="d-flex cursor-pointer br-0 p-2 justify-content-start"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <small className="f-5 ">{item?.name}</small>
                    </div>
                  </DropdownItem>
                ))}
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

export default StateSelectInput;
